import { generateCreateActionCreator, generateReadActionCreator, generateReadOneActionCreator } from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';
import routes from 'actions/routes';
import { matchPath } from 'react-router-dom';

const getTextPanelConversations = generateReadActionCreator(routes.API_CONVERSATION_TEXT, ACTION_NAMES.TEXT_PANEL_CONVERSATION_TEXT);
const getFilteredMessagesForTextPanel = generateReadActionCreator(routes.API_MESSAGES_TEXT, ACTION_NAMES.FILTER_MESSAGES_FOR_TEXT_PANEL);
const getFilteredMessagesForTextOfficeView = generateReadActionCreator(routes.API_MESSAGES_TEXT, ACTION_NAMES.FILTER_MESSAGES_FOR_TEXT_OFFICE_VIEW);
const getFilteredMessages = generateReadActionCreator(routes.API_MESSAGES_TEXT, ACTION_NAMES.FILTER_MESSAGES_TEXT);
const getConversations = generateReadActionCreator(routes.API_CONVERSATION_TEXT, ACTION_NAMES.CONVERSATION_TEXT);
const getTextHistoryConversations = generateReadActionCreator(routes.API_CONVERSATION_TEXT, ACTION_NAMES.TEXT_HISTORY_CONVERSATION_TEXT);
const getFilteredMessagesForTextHistory = generateReadActionCreator(routes.API_MESSAGES_TEXT, ACTION_NAMES.FILTER_MESSAGES_FOR_TEXT_HISTORY);
const refreshTextConversationComponents = ({ from, to }) => (dispatch, getState) => {
    const activeSecondarySidebar = getState().left_sidebar_ui.activeSecondarySidebar;
    const isTextPanelVisible = activeSecondarySidebar === "text"

    const isConversationBeingViewed = (contact_phone, customer_phone) => {
        return from?.includes(contact_phone) && to?.includes(customer_phone);
    }
    if (isTextPanelVisible) {
        const { textPanelConversationRecipient: contact_phone, textPanelConversationSender: customer_phone } = getState().text;
        if (isConversationBeingViewed(contact_phone, customer_phone)) {
            dispatch(getFilteredMessagesForTextPanel({ contact_phone, customer_phone }));
        }
    }
    const isOfficeViewTextPanelVisible = activeSecondarySidebar === "view" && getState().officeView.selectedTab === 2;
    if (isOfficeViewTextPanelVisible) {
        const { officeViewConversationRecipient: contact_phone, officeViewConversationSender: customer_phone } = getState().text;
        if (isConversationBeingViewed(contact_phone, customer_phone)) {
            dispatch(getFilteredMessagesForTextOfficeView({ contact_phone, customer_phone }));
        }
    }

    const pathname = window.location.pathname;
    if (!!(matchPath("/contact/:id/texts", pathname) || matchPath("/account/:id/texts", pathname))) {
        const { textTabConversationRecipient: contact_phone, textTabConversationSender: customer_phone } = getState().text;
        if (isConversationBeingViewed(contact_phone, customer_phone)) {
            dispatch(getFilteredMessages({ contact_phone, customer_phone }));
        }
    } else if (!!(matchPath("/settings/text-history", pathname) || matchPath("/text-history", pathname))) {
        const { textHistoryConversationRecipient: contact_phone, textHistoryConversationSender: customer_phone } = getState().text;
        if (isConversationBeingViewed(contact_phone, customer_phone)) {
            dispatch(getFilteredMessagesForTextHistory({ contact_phone, customer_phone }));
        }
    }
}
const getUnsubscribed = generateReadActionCreator(routes.API_TEXT_UNSUBSCRIBED, ACTION_NAMES.TEXT_UNSUBSCRIBED);

export default {
    sendText: generateCreateActionCreator(routes.API_TEXT, ACTION_NAMES.TEXT),
    getLogs: generateReadActionCreator(routes.API_TEXT_LOGS, ACTION_NAMES.TEXT_LOGS),
    getUsers: generateReadActionCreator(routes.API_TEXT_USERS, ACTION_NAMES.TEXT_USERS),
    getPhones: generateReadActionCreator(routes.API_PHONE_TEXT, ACTION_NAMES.PHONE_TEXT),
    getConversations: getConversations,
    getTextPanelConversations: getTextPanelConversations,
    getTextHistoryConversations: getTextHistoryConversations,
    getFilteredMessagesForTextHistory: getFilteredMessagesForTextHistory,

    getFilteredMessages: getFilteredMessages,
    getFilteredMessagesForTextPanel: getFilteredMessagesForTextPanel,
    getFilteredMessagesForTextOfficeView: getFilteredMessagesForTextOfficeView,
    getContactInfo: generateReadOneActionCreator(routes.API_CONTACT, ACTION_NAMES.TEXT_CONTACT_INFO),
    getOfficeViewContactInfo: generateReadOneActionCreator(routes.API_CONTACT, ACTION_NAMES.OFFICE_VIEW_TEXT_CONTACT_INFO),
    getAccountInfo: generateReadOneActionCreator(routes.API_ACCOUNT, ACTION_NAMES.TEXT_ACCOUNT_INFO),
    getRecipientPhones: generateReadOneActionCreator(routes.API_CONTACT, ACTION_NAMES.TEXT_RECIPIENT_PHONES, 'phone'),
    getContactPhones: generateReadActionCreator(routes.API_CONTACT_PHONE_TEXT, ACTION_NAMES.CONTACT_PHONE_TEXT),

    setTextPanelQueryParameters: (queryParams) => ({
        type: ACTION_NAMES.SET_TEXT_PANEL_QUERY_PARAMETERS,
        query: queryParams
    }),

    setConversationBeingViewedInTextPanel: (query) => ({
        ...query,
        type: ACTION_NAMES.SET_TEXT_PANEL_CONVERSATION_BEING_VIEWED
    }),

    refreshTextingComponents: ({ from, to }) => (dispatch, getState) => {
        const activeSecondarySidebar = getState().left_sidebar_ui.activeSecondarySidebar;
        const isTextPanelVisible = activeSecondarySidebar === "text"

        if (isTextPanelVisible) {
            const { textPanelQuery } = getState().text;
            dispatch(getTextPanelConversations(textPanelQuery));
        }
        const params = new URLSearchParams(window.location.search);

        const pathname = window.location.pathname;
        if (!!(matchPath("/contact/:id/texts", pathname) || matchPath("/account/:id/texts", pathname))) {
            const fromPhones = params.get('from')?.split(",") || getState().text.phones || [];
            const toPhones = params.get('to')?.split(",") || getState().contact_phone.phone?.map(phone => phone.phone) || [];
            const search = params.get('search') || '';
            const page = params.get('page') || 1;
            dispatch(getConversations(!search ? {
                contact_phone: toPhones,
                page,
                limit: 25,
                customer_phone: fromPhones
            } : {
                search_phone: search,
                page
            }));
        } else if (!!(matchPath("/settings/text-history", pathname) || matchPath("/text-history", pathname))) {
            const search = params.get('search') || '';
            const page = params.get('page') || 1;
            dispatch(getTextHistoryConversations(!search ? {
                contact_phone: params.get('to')?.split(",") || undefined,
                page: page,
                limit: 25,
                customer_phone: params.get('from')?.split(",") || undefined
            } : {
                search_phone: search,
                page
            }));
        }
        dispatch(refreshTextConversationComponents({ from, to }));
    },
    refreshTextConversationComponents: refreshTextConversationComponents,

    setConversationBeingViewedInTextTab: (query) => ({
        ...query,
        type: ACTION_NAMES.SET_TEXT_TAB_CONVERSATION_BEING_VIEWED
    }),

    setConversationBeingViewedInOfficeView: (query) => ({
        ...query,
        type: ACTION_NAMES.SET_OFFICE_VIEW_CONVERSATION_BEING_VIEWED
    }),

    setConversationBeingViewedInTextHistory: (query) => ({
        ...query,
        type: ACTION_NAMES.SET_TEXT_HISTORY_CONVERSATION_BEING_VIEWED
    }),
    getUnsubscribed: getUnsubscribed
}
